import { useRef } from "react";
import { IMaskInput } from "react-imask";
import { hasValidExpiryDate } from "js/utilities";

export default function MaskedExpirationDateInput({
  name,
  describedby,
  register,
  setValue,
  defaultValue,
  setState,
  errorMessage = "The expiration date must be a future date",
}) {
  const ref = useRef(null);

  return (
    <IMaskInput
      ref={ref}
      mask={"00/0000"}
      defaultValue={defaultValue}
      placeholder="MM/YYYY"
      unmask={false}
      lazy={true}
      placeholderChar="X"
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={
        // depending on prop above first argument is
        // `value` if `unmask=false`,
        // `unmaskedValue` if `unmask=true`,
        // `typedValue` if `unmask='typed'`
        (value, mask) => {
          if (value?.length === 7) {
            setState(false);
          } else setState(true);
          if (hasValidExpiryDate(value)) {
            setValue(name, value);
          } else {
            setValue(name, "");
          }
        }
      }
      {...register(name, {
        required: errorMessage,
      })}
      aria-describedby={describedby}
    />
  );
}
